module.exports = __webpack_public_path__ + "static/media/minusVector.df9777f9.svg";